import { DeleteOutlineOutlined } from '@mui/icons-material';

interface DeleteConfirmWarningProps {
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteConfirmWarning = ({
  onClose,
  onConfirm,
}: DeleteConfirmWarningProps) => {
  return (
    <div className="modal-content align-flex-center">
      <div>
        <h2 className="modal-content__title">Delete Session</h2>
        <p className="modal-content__warning">
          Are you sure you want to delete this session? This action cannot be undone.
        </p>
      </div>
      <div className="modal-content__buttons">
        <button
          className="modal-content__buttons__cancel"
          type="button"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          className="modal-content__buttons__delete"
          type="button"
          onClick={onConfirm}
        >
          <DeleteOutlineOutlined fontSize="small" />
          Delete
        </button>
      </div>
    </div>
  );
};

export default DeleteConfirmWarning;
